<div class="content">
  <div class="scroll" id="scrollingForm">
    <h5 *ngIf="isSplitScreenOn">
      {{
        createTitle
          | translate
            : {
                layer_type: (currOrtho.layer_type | translate | titlecase),
                layer_date: (currOrtho.layer_date | date: "dd/MM/yyyy")
              }
      }}
    </h5>
    <div class="form-container">
      <form [formGroup]="form">
        <div>
          <div class="annot-thumbnail" style="background-color: #eeeeee">
            <img
              class="rounded"
              [src]="
                mapScreenshot
                  ? mapScreenshot
                  : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='
              "
              style="width: 100%; height: inherit"
              [style.height]="mapScreenshot ? 'inherit' : '13em'"
            />
            <button
              class="btn btn-sm btn-secondary btn-screenshot"
              (click)="setMapScreenshot()"
            >
              {{ "Screenshot" | translate }}
            </button>
          </div>
          <!-- <div class="form-group">
                        <input formControlName="area" type="text" class="form-control" placeholder="{{ 'Area' | translate }}">
                    </div> -->
          <div class="form-group" *ngIf="showAreaSize">
            <input
              formControlName="area_size"
              type="text"
              class="form-control"
              [value]="form?.get('area_size').value"
              placeholder="{{ 'Area Size' | translate }}"
            />
            <span class="text-muted">{{ isSquareMeter ? "m²" : "m" }}</span>
          </div>
          <div class="form-group">
            <label>{{ "Details" | translate }}</label>
            <input
              formControlName="name"
              type="text"
              class="form-control"
              placeholder="{{ 'Annotation Name' | translate }}"
            />
          </div>
          <div class="form-group">
            <textarea
              formControlName="description"
              class="form-control"
              placeholder="{{ 'Description' | translate }}"
            ></textarea>
          </div>
          <div class="form-group">
            <input
              formControlName="kp"
              class="form-control"
              placeholder="{{ 'KP' | translate }}"
            />
          </div>
          <div class="form-group">
            <input
              formControlName="area_centroid"
              class="form-control"
              placeholder="{{ 'Center Coordinate' | translate }}"
              [attr.disabled]="true"
            />
          </div>
          <div class="form-group">
            <label>{{ "Flight Date" | translate }}</label>
            <input
              formControlName="flight_date"
              type="date"
              class="form-control"
              placeholder="{{ 'Flight Date' | translate }}"
            />
          </div>
          <div class="form-group">
            <input
              formControlName="status"
              class="form-control"
              placeholder="{{ 'Status' | translate }}"
            />
          </div>
          <div class="form-group">
            <select formControlName="location_component" class="form-control">
              <option value="" disabled selected>
                {{ "Select location component" | translate }}
              </option>
              <option
                *ngFor="let component of locationComponentList; trackById"
                [value]="component.id"
              >
                {{ component.name | translate | titlecase }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <select formControlName="annotation_type" class="form-control">
              <option value="" disabled selected>
                {{ "Select defect type" | translate }}
              </option>
              <option
                *ngFor="let defectType of defectTypes; trackById"
                [value]="defectType.id"
              >
                {{ defectType.name | translate | titlecase }}
              </option>
            </select>
          </div>
          <div class="form-group severity">
            <label>{{ "Severity" | translate }}</label>
            <div class="d-block">
              <span
                *ngFor="let severity of severityList; trackById"
                class="btn-tool"
              >
                <input
                  formControlName="severity_type"
                  type="radio"
                  [id]="severity.id"
                  [value]="severity.id"
                  (change)="changeSeverity(severity.id)"
                />
                <label
                  [for]="severity.id"
                  class="btn btn-sm btn-circle"
                  [style.backgroundColor]="severity.description"
                  [class.active]="
                    form.get('severity_type').value === severity.id
                  "
                >
                </label
                ><span
                  class="tooltip-text"
                  style="margin-top: -2.3em; margin-left: -3em"
                  >{{ severity.name | titlecase }}</span
                >
              </span>
            </div>
          </div>
          <!-- <div class="form-group">
                        <select formControlName="map_layer" class="form-control" (change)="showRespectiveMap($event.target['value'])">
							<option value="" disabled selected>{{ 'Select map layer' | translate }}</option>
							<option *ngFor="let ml of mapLayerList; trackById" [value]="ml.id">{{ ml.layer_type | translate | titlecase }}
							</option>
						</select>
                    </div> -->
        </div>
      </form>
    </div>
    <ng-container *ngFor="let i of isFormShow; trackById">
      <ng-container *ngIf="i === 'discussion'">
        <ng-container *ngTemplateOutlet="discussion"></ng-container>
      </ng-container>
      <ng-container *ngIf="i === 'task'">
        <ng-container *ngTemplateOutlet="task"></ng-container>
      </ng-container>
      <ng-container *ngIf="i === 'attachment'">
        <ng-container *ngTemplateOutlet="attachment"></ng-container>
      </ng-container>
    </ng-container>
    <div
      class="float-btn-group"
      [class.open]="actionBtn"
      (click)="toggleActionBtn()"
    >
      <button class="btn-float btn-triger bg-primary">
        <i class="icon-bars"></i>
      </button>
      <div class="btn-list">
        <a
          class="btn-float"
          [ngClass]="
            isFormShow.includes('discussion') ? 'bg-primary text-light' : ''
          "
          (click)="toggleFormIsShow('discussion')"
        >
          <i class="icon-discussion"></i>
        </a>
        <a
          class="btn-float"
          [ngClass]="isFormShow.includes('task') ? 'bg-primary text-light' : ''"
          (click)="toggleFormIsShow('task')"
        >
          <i class="icon-tasks"></i>
        </a>
        <a
          class="btn-float"
          [ngClass]="
            isFormShow.includes('attachment') ? 'bg-primary text-light' : ''
          "
          (click)="toggleFormIsShow('attachment')"
        >
          <i class="icon-files"></i>
        </a>
      </div>
    </div>
  </div>
  <div class="form-buttons">
    <button
      type="button"
      class="btn btn-sm btn-secondary"
      (click)="onCancelClicked($event)"
    >
      {{ "Cancel" | translate }}
    </button>
    <button type="submit" class="btn btn-sm btn-primary" (click)="onSubmit()">
      {{ "Save" | translate }}
    </button>
  </div>
</div>

<ng-template #discussion>
  <div
    class="form-container chat-form"
    [class.d-none]="!isFormShow.includes('discussion')"
  >
    {{ "Discussion" | translate }}
    <div class="chat-list mt-2">
      <div
        class="mb-1"
        [ngClass]="
          currentUser.user_id === chat.sender.id ? 'me bg-primary' : 'other'
        "
        *ngFor="let chat of chats; trackById"
      >
        <p>{{ chat.content }}</p>
        <p
          [ngClass]="currentUser.user_id === chat.sender.id ? 'text-right' : ''"
        >
          <small>- {{ chat.sender.username }}</small>
        </p>
      </div>
    </div>
    <form [formGroup]="chatForm">
      <div>
        <div class="form-group">
          <textarea
            formControlName="message"
            type="text"
            class="form-control"
            (keyup.enter)="sendChat()"
            placeholder="{{ 'Message' | translate }}"
          ></textarea>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #task>
  <div class="form-container">
    <app-task-form
      [task]="taskForm?._value"
      [inAnnote]="true"
      (onValueChanges)="taskForm.value = $event"
      (validForm)="taskForm.valid = $event"
    ></app-task-form>
  </div>
</ng-template>

<ng-template #attachment>
  <div
    class="form-container"
    [class.d-none]="!isFormShow.includes('attachment')"
  >
    {{ "Attachment" | translate }}
    <form [formGroup]="galleryForm" class="mt-2">
      <div class="form-group">
        <!-- <div class="custom-file">
                    <input formControlName="file" type="file" class="custom-file-input" id="customFile" (change)="onFileSelected($event)">
                    <label class="custom-file-label" for="customFile" [data-browse]={{browseText}}>{{ 'Choose file' | translate }}</label>
                </div> -->
        <app-file-upload></app-file-upload>
      </div>
    </form>
  </div>
</ng-template>
